// assets
import { IconHome, IconChartBarPopular } from '@tabler/icons-react';

// constant
const icons = { IconHome, IconChartBarPopular };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Tablero',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Estadísticas de producción',
            type: 'item',
            url: '/',
            icon: icons.IconChartBarPopular,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
